<template>
  <Modal
    class="!tw-top-[155px] !tw-translate-y-0 wizard-setup-modal tw-max-w-[1263px] !tw-z-[1070]"
    :visible="showRef"
    :overflow-y-visible="true"
    border-radius="4px"
    :close-on-backdrop-click="true"
    @close="handleCloseModal"
  >
    <ModalHeader
      style="z-index: 10"
      :class="`modal-header tw-bg-[#FFFFFF]`"
      :title="
        getComponentUiText('app-menu-submenu-home-setup-wizard-modal-title-1')
      "
      @close="handleCloseModal"
    />

    <div
      :class="`
       wizard-container`"
    >
      <BrandPattern5 class="!tw-top-0 !tw-h-full" page="APPBARLAYOUT" />

      <div
        :class="[
          stateActive !== -1 ? 'show' : '',
          'tw-flex tw-bg-transparent wizard-content',
        ]"
      >
        <WizardWellcome
          :class="`tw-w-[50%] tw-z-[1] ${isPagesShown ? 'tw-opacity-0' : ''}`"
          @update:state="showContent(0)"
        />
        <!-- Content -->
        <WizardWrapper
          :class="['tw-w-[50%]']"
          :show-state-component="stateActive"
          :is-status-api-setup-ready="isStatusApiSetup"
          @update:active-component="(value) => (activeComponent = value)"
          @get-is-answered="(value) => (isAnswered = value)"
        />
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import BrandPattern5 from "@/components/prospect/brandPattern/brandPattern5.vue";
import { Ref, computed, onMounted, ref, watch } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import WizardWellcome from "./wizardWellcome.vue";
import WizardWrapper from "./wizardWrapper.vue";
import { INDEX_PRIMARY_PAGE, MODAL_NAME } from "@/utils/constants";
import { IModalMessage } from "@/interfaces/common/common";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import store from "@/store";
import { useRoute, useRouter } from "vue-router";
import { onUnmounted } from "vue";
import eventEmitter from "@/utils/eventEmitter";

const emit = defineEmits(["update:show", "get-is-answered"]);
const props = defineProps({
  show: { type: Boolean, required: false },
});

const isStatusApiSetup = computed(
  () => store.state.SetupWizard.isStatusApiSetup,
);

const route = useRoute();
const router = useRouter();
const stateActive: Ref<number> = ref(-1);
const activeComponent: Ref<number> = ref(-1);
const isAnswered: Ref<boolean> = ref(false);
const isPagesShown = ref(false);
let showRef = ref(props.show);

const isDirty = computed(() => {
  return store.getters["SetupWizard/isDirty"];
});

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) getWizardGlobalData();
  },
);

onMounted(() => {
  getWizardGlobalData();
  EventEmitter.on(EmitterEvents.CLOSE_MODAL, closeModal);
  const queryValue = route.query?.type;
  if (queryValue && isStatusApiSetup.value) {
    setTimeout(() => showContent(0), 200);
  }
});

watch(
  () => isStatusApiSetup.value,
  (value) => {
    const queryValue = route.query?.type;
    if (queryValue && value) {
      setTimeout(() => showContent(0), 200);
    }
  },
);

onUnmounted(() => {
  EventEmitter.off(EmitterEvents.CLOSE_MODAL, closeModal);
});

const closeModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const handleCloseModal = () => {
  if (!isDirty.value) {
    // not changing, redirect to home
    eventEmitter.emit(
      EmitterEvents.SET_PRIMARY_MENU_INDEX,
      INDEX_PRIMARY_PAGE.home,
    );
    return router.push({ path: "/" });
  }

  // changing, show modal
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_WIZARD_SAVE_EXIT,
    properties: {
      isMoreInfoModal: true,
      isAnswered: isAnswered.value,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);

  // showRef.value = false;
  // emit("update:show", showRef.value);
};

const getWizardGlobalData = () => {
  store.commit("SetupWizard/SET_STATE_API_SETUP", false);
  store.dispatch("SetupWizard/fetchQuestion");
};

const showContent = async (state: number) => {
  stateActive.value = state;
  await new Promise((resolve) => setTimeout(resolve, 510));
  isPagesShown.value = true;
};
</script>

<style lang="scss" scoped>
.wizard-setup-modal {
  max-height: calc(100vh - 200px) !important;
  .wizard-container {
    overflow: hidden;
    overflow-y: auto;
    width: 100%;
    height: 100%;
    background: rgba(239, 240, 241, 0.5);

    .wizard-content {
      padding: 0;
      min-width: 200%;
      transition: 0.3s ease-in-out;

      &.show {
        transform: translateX(-50%);
      }
    }
  }
}
</style>
